import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Input } from 'core-components/library/inputs'
import { updateAssortmentItem } from 'partner360/features/assortment/assortmentSlice'
import { IAssortmentItem } from 'partner360/features/assortment/models/data/IAssortmentItem'

import { TRANSLATION_KEYS } from '../../../../translations'

import styles from './FieldsSet.module.scss'

interface IFieldsSetProps {
  isEditMode?: boolean
  item: IAssortmentItem
}

export const FieldsSet: FC<IFieldsSetProps> = ({ isEditMode = false, item }) => {
  const dispatch = useAppDispatch()

  const changeAssortmentItem = useCallback(
    (field: keyof IAssortmentItem, value: string) => {
      dispatch(
        updateAssortmentItem({
          ...item,
          [field]: value,
        })
      )
    },
    [dispatch, item]
  )

  const changeNumberOfSuppliers = useCallback(
    (suppliers: string) => {
      changeAssortmentItem('Suppliers', suppliers)
    },
    [changeAssortmentItem]
  )

  const changeNumberOfConfigs = useCallback(
    (configs: string) => {
      changeAssortmentItem('Configs', configs)
    },
    [changeAssortmentItem]
  )

  const changeNumberOfUnits = useCallback(
    (units: string) => {
      changeAssortmentItem('Units', units)
    },
    [changeAssortmentItem]
  )

  if (isEditMode) {
    return (
      <div className={styles.editMode}>
        <div className={styles.row}>
          <Input
            label={<Translation text={TRANSLATION_KEYS.item.suppliers} />}
            value={item.Suppliers}
            onChange={changeNumberOfSuppliers}
          />
          <Input
            label={<Translation text={TRANSLATION_KEYS.item.configs} />}
            value={item.Configs}
            onChange={changeNumberOfConfigs}
          />
          <Input
            label={<Translation text={TRANSLATION_KEYS.item.units} />}
            value={item.Units}
            onChange={changeNumberOfUnits}
          />
        </div>
        {/* <Input label="extra comment" /> */}
      </div>
    )
  }

  return (
    <div className={styles.viewMode}>
      <div className={styles.readRow}>
        <div className={styles.readLabel}>
          <Translation text={TRANSLATION_KEYS.item.configs} />
        </div>
        <div className={styles.readValue}>{item.Configs}</div>
      </div>
      <div className={styles.readRow}>
        <div className={styles.readLabel}>
          <Translation text={TRANSLATION_KEYS.item.units} />
        </div>
        <div className={styles.readValue}>{item.Units}</div>
      </div>
    </div>
  )
}
